import { isExist } from '@util/data/is-exist';

export const queryBuilder = (data: Record<string, any> = {}) =>
  Object.fromEntries(Object.entries(data).filter(([, value]) => isExist(value)));
